export const DRAWER_WIDTH = 300;
export const DRAWER_MINI_WIDTH = 85;
export const APPBAR_HEIGHT = 65;
export const ADMIN_VIEW_MODE_STORAGE_KEY = 'adminViewMode';
export const CONTAINER_FULL_WIDTH_STORAGE_KEY = 'containerFullWidth';
